import { useContext } from 'react';
import { ClientDetailsTableContext, IClientDetailsTableContext } from './ClientDetailsTableContext';

export const useClientDetailsTable = () => useContext<IClientDetailsTableContext>(ClientDetailsTableContext);
